// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tf-0";
export var checkoutRateBadgeLink = "_tf-1";